import { CityText } from './Styled'

const Cities = (cities, domain) => {
  const showNoFollow = domain === 'housekeeper.com'

  if (!cities.cities) {
    return null
  } else {
    return (
      cities.cities &&
      cities.cities.length > 0 &&
      cities.cities.map((item) => (
        <CityText
          textAlign={{ _: 'center', desktop: 'left' }}
          href={`https://${item.url}`}
          key={item.url}
          rel={showNoFollow ? 'nofollow' : ''}
        >
          {item.title}
        </CityText>
      ))
    )
  }
}

export default Cities
